import { useSelector } from 'react-redux';

import { pageTitleIdSel } from '@location';
import { appName } from '@shared';
import { intl } from '@shared/localization';

const PageTitle = () => {
  const titleId = useSelector(pageTitleIdSel);

  let title = appName;
  if (titleId) {
    title = `${intl.formatMessage({ id: titleId })} | ${title}`;
  }
  document.title = title;

  return '';
};

export default PageTitle;
